module.exports = __webpack_public_path__ + "assets/img/14.0727afed.png";